/** Shelf cover images — shared for offline prefetch. */
export const TRIP_COVER_IMAGES = {
  Slovenia: 'https://images.unsplash.com/photo-1527004013197-933c4bb611b3?w=900&q=80',
  default: 'https://images.unsplash.com/photo-1501785888041-af3ef285b470?w=900&q=80',
};

export function tripCoverUrl(country) {
  return TRIP_COVER_IMAGES[country] ?? TRIP_COVER_IMAGES.default;
}
